import { ManufacturedMobileContactInfo } from '../../cards/contact-info-short/manufactured-mobile';
import EarlyKickOut from '../../cards/early-kick-out';
import PropertyType from '../../cards/property-type';
import { Branch, Card, End } from '../../components/deck';

/**
 * Gets your property type then branches to an early termination if your
 *   property type is Manufactured or Mobile.
 *
 * @param {*} continuation - Path to continue on if validation passes
 */

export const PropertyTypeBranch = (continuation) =>
  Card(
    PropertyType,
    Branch(
      {
        manufacturedMobile: Card(ManufacturedMobileContactInfo, Card(EarlyKickOut, End()))
      },
      ({ model }) =>
        ['Manufactured', 'Mobile'].includes(model.getIn(['loan', 'propertyType']))
          ? 'manufacturedMobile'
          : null,
      continuation
    )
  );



// WEBPACK FOOTER //
// ./src/decks/branches/property-type.js